var ProductVariation = Backbone.Model.extend({
    defaults: {
        'post_id': 0,
        'name' : '',
        'sku' : '',
        'has_sub_variations' : false,
        'sub_variations': null,
        'family' : '',
        'exclusions' : [],
        'options' : [],
        'outdoor' : 0,
        'image' : ''
    },
    initialize: function(){
        if ( this.get( 'has_sub_variations' ) ) {
            let subs = this.get( 'sub_variations' );
            if ( Array.isArray(subs) && subs.length ) {
                let subVariations = new Backbone.Collection();
                var i, s, subModel;
                for ( i = 0; i < subs.length; i++ ) {
                    s = subs[i];
                    s.family = this.get( 'family' );
                    subModel = new ProductVariation(s);
                    subVariations.add( subModel );
                }
                this.set({ 'sub_variations': subVariations });
            }
        }
    }
});
export {ProductVariation};